frontApp.buttonScroll = {
  name: 'buttonScroll',
  description: 'button scroll page down and up',
  btnEl: '.js-button-scroll',
  previousTop: 0,
  savedPosition: null,
  scrollBack: false,
  isDisabled: false,
  smoothScroll: null,
  duration: 500,
  init() {
    this.smoothScroll = new SmoothScroll(null, {
      speed: this.duration,
      speedAsDuration: true,
    });

    window.addEventListener('scroll', () => {
      if (!window.requestAnimationFrame) {
        setTimeout(this.checkScrollPosition.bind(this), 250);
      } else {
        requestAnimationFrame(this.checkScrollPosition.bind(this));
      }
    });

    this.events();
  },
  checkScrollPosition() {
    const btn = document.querySelector(this.btnEl);
    const scrollTop = window.scrollY;
    if (scrollTop < 500) {
      if (this.savedPosition === null) {
        btn.classList.remove('is-show');
      }
    } else {
      if (this.previousTop < scrollTop) {
        this.savedPosition = null;
        this.scrollBack = false;
        btn.classList.remove('is-back');
      }
      btn.classList.add('is-show');
    }
    this.previousTop = scrollTop;
  },
  events() {
    const self = this;
    const btn = document.querySelector(this.btnEl);
    if (btn) {
      btn.addEventListener('click', function () {
        if (self.isDisabled) {
          return false;
        }
        self.isDisabled = true;
        setTimeout(() => {
          self.isDisabled = false;
        }, self.duration);
        if (self.scrollBack) {
          self.scrollBack = false;
          self.smoothScroll.animateScroll(self.savedPosition);
          this.classList.remove('is-back');
        } else {
          self.scrollBack = true;
          self.savedPosition = window.scrollY;
          self.smoothScroll.animateScroll(0);
          this.classList.add('is-back');
        }
      });
    }
  },
};
